/**
 *
 */

var ContactTeam = (function($) {
  var teamSwiper;

  function getSwiperInstance() {
    if (!teamSwiper) {
      teamSwiper = document.querySelector(".contact-team-slider")?.swiper;
    }

    return teamSwiper;
  }

  function updateActiveState($link) {
    $(".contact-team-menu__item").removeClass(
      "contact-team-menu__item--active"
    );
    $link
      .closest(".contact-team-menu__item")
      .addClass("contact-team-menu__item--active");
  }

  function updateCvLinks(department) {
    $(".contact-team-cv__link").removeClass("is-active");
  }

  function scrollToCv() {
    var $target = $(".contact-team-cv");

    if (!$target.length) return;

    var offset = 120;
    var targetTop = $target.offset().top - offset;

    $("html, body")
      .stop()
      .animate(
        {
          scrollTop: targetTop
        },
        700
      );
  }

  function filterSlides(department) {
    var $slides = $(".contact-team-slide");
    var swiper = getSwiperInstance();

    $slides.each(function() {
      var $slide = $(this);
      var departments = $slide.data("department");
      var shouldShow = false;

      if (department === "all") {
        shouldShow = true;
      } else if (departments) {
        var departmentList = departments.toString().split(" ");
        shouldShow = departmentList.indexOf(department) !== -1;
      }

      if (shouldShow) {
        $slide.removeClass("contact-team-slide--hidden");

        gsap.to($slide, {
          autoAlpha: 1,
          duration: 0.35,
          ease: "power2.out",
          onStart: function() {
            $slide.css("display", "");
          },
          onComplete: function() {
            if (swiper) {
              swiper.update();
            }
          }
        });
      } else {
        gsap.to($slide, {
          autoAlpha: 0,
          duration: 0.35,
          ease: "power2.out",
          onComplete: function() {
            $slide.addClass("contact-team-slide--hidden");
            $slide.css("display", "none");

            if (swiper) {
              swiper.update();
            }
          }
        });
      }
    });

    if (swiper) {
      setTimeout(function() {
        swiper.slideTo(0, 400);
        swiper.update();
      }, 600);
    }
  }

  function initContactTeam() {
    $(".contact-team-menu__link").on("click", function(e) {
      e.preventDefault();

      var $this = $(this);
      var department = $this.data("department");

      updateActiveState($this);

      filterSlides(department);
      updateCvLinks(department);
    });
  }

  function initContactFilter() {
    $(".contact-team-menu__item--filter").click(function() {
      $(".contact-team-menu").slideToggle();
      $(".contact-team-menu").toggleClass("contact-team-menu--expanded");
    });
  }

  function init() {
    if (!$(".contact-team-menu").length || !$(".contact-team-slide").length) {
      return;
    }

    initContactTeam();
    initContactFilter();
  }

  return {
    init: init
  };
})(jQuery);

jQuery(document).ready(ContactTeam.init);
